import { ACTION, displayLabel } from '../../../common/const/lei-products';

/**
 * Quantity lines for the pay page. Claim & renew is priced as RENEW, so the server counts it
 * under RENEW in metaData; claimRenewCount splits it back out for display only.
 * Returns [] when a single line (the product description) already says it all.
 */
export function quantityBreakdown({ isMixed, metaData, count, claimRenewCount = 0 }) {
  let lines = [];
  if (isMixed) {
    lines = Object.keys(metaData || {}).map(type => ({ type, num: metaData[type].num }));
  } else if (claimRenewCount > 0 && claimRenewCount < count) {
    lines = [{ type: ACTION.RENEW, num: count }];
  } else {
    return [];
  }

  if (claimRenewCount > 0) {
    lines.forEach(line => {
      if (line.type === ACTION.RENEW) {
        line.num -= claimRenewCount;
      }
    });
    lines.push({ type: ACTION.CLAIMRENEW, num: claimRenewCount });
  }
  return lines.map(({ type, num }) => ({ label: displayLabel[type] || type, num }));
}

/** Renames a renew product description when every item in the checkout is a claim & renew. */
export function checkoutProductDescription({ description, isMixed, count, claimRenewCount = 0 }) {
  if (!isMixed && count > 0 && claimRenewCount === count) {
    return description.replace('Renew LEI', 'Claim & Renew LEI');
  }
  return description;
}
